import { render, staticRenderFns } from "./WizardConnect.vue?vue&type=template&id=1368d78e&scoped=true&"
import script from "./WizardConnect.vue?vue&type=script&lang=ts&"
export * from "./WizardConnect.vue?vue&type=script&lang=ts&"
import style0 from "./WizardConnect.vue?vue&type=style&index=0&id=1368d78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368d78e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VOtpInput,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1368d78e')) {
      api.createRecord('1368d78e', component.options)
    } else {
      api.reload('1368d78e', component.options)
    }
    module.hot.accept("./WizardConnect.vue?vue&type=template&id=1368d78e&scoped=true&", function () {
      api.rerender('1368d78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/WizardConnect.vue"
export default component.exports